import { Alert, Icons, useToggle } from '@commenda/kakashi';
import { MarkdownRenderer } from '../../../../components/MarkdownRenderer';

type WorkflowNoDocumentNoticeProps = {
  summary?: string;
};

/** Warns that a document-work agent step completed without producing a file, with the agent's own reason expandable. */
export const WorkflowNoDocumentNotice = ({
  summary,
}: WorkflowNoDocumentNoticeProps) => {
  const isReasonExpanded = useToggle(false);

  return (
    <div className="mt-sm">
      <Alert
        variant="warning"
        icon={<Icons.AlertTriangle className="size-5 text-text-warning" />}
        title="Completed — no document produced"
        description={
          summary && isReasonExpanded.value ? (
            <div className="txt-small-regular text-text-secondary">
              <MarkdownRenderer content={summary} />
            </div>
          ) : undefined
        }
        action={
          summary
            ? {
                label: isReasonExpanded.value ? 'Hide reason' : 'Show reason',
                onClick: isReasonExpanded.toggle,
                icon: isReasonExpanded.value ? (
                  <Icons.ChevronUp className="size-4" />
                ) : (
                  <Icons.ChevronDown className="size-4" />
                ),
              }
            : undefined
        }
      />
    </div>
  );
};
